/**
 * Canonical URL utility functions
 * Helps prevent duplicate content issues from UTM parameters and other URL variations
 */

/**
 * Get the canonical URL for the current page
 * Removes UTM parameters and other tracking parameters
 * @param {string} pathname - The current pathname
 * @param {string} baseUrl - The base URL (default: https://dataflows.com.au)
 * @returns {string} Clean canonical URL
 */
export const getCanonicalUrl = (pathname = '/', baseUrl = 'https://dataflows.com.au') => {
  // Remove trailing slash if not root
  const cleanPath = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
  
  // Combine base URL with clean path
  return `${baseUrl}${cleanPath}`;
};

/**
 * Get current page path without query parameters
 * @returns {string} Current pathname
 */
export const getCurrentPath = () => {
  if (typeof window !== 'undefined') {
    return window.location.pathname;
  }
  return '/';
};

/**
 * Parameters to remove from URLs for canonical purposes
 */
export const TRACKING_PARAMS = [
  'utm_source',
  'utm_medium', 
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
  'msclkid',
  '_ga',
  'ref',
  'source'
];